// extracted by mini-css-extract-plugin
export default {"layout":"stayle_layout__yiIC+","layout__wrapper":"stayle_layout__wrapper__RmmQ8"};